// @flow

import * as React from 'react';
import AceEditor from 'react-ace';
import brace from 'brace';
import 'brace/mode/jsx';
import 'brace/mode/less';
import 'brace/theme/monokai';

import { Header } from './components/Header';
import AdsumClock from './components/adsum-clock';

import './App.css';

const ClockUi = props => (
    <pre className="withJson">
        { JSON.stringify(props, null, 2) }
    </pre>
);

const ClockUi2 = (props) => (
    <div role="presentation" className="adsum-clock-wrapper">
        <div className="adsum-clock">
            <div className="day-date">{props.dateStr}</div>
            <div className="time">{props.timeStr}</div>
        </div>
    </div>
);

const Clock = AdsumClock(ClockUi2);
const Clock2 = AdsumClock(ClockUi);

type PropsType = {||};

class App extends React.Component<PropsType> {
    render() {
        return (
            <div className="App">
                <Header logo="http://adactivesas.github.io/adsum-react-components/logo.jpg" />

                <h3>Styles used for examples</h3>

                <div className="snippetWrapper">
                    <div className="code">
                        <AceEditor
                            mode="less"
                            theme="monokai"
                            name="UNIQUE_ID_OF_DIV"
                            editorProps={{ $blockScrolling: true }}
                            fontSize={14}
                            value={`
.adsum-clock-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;

  .adsum-clock {
    color: lightgray;
    text-align: center;

    .day-date {
      margin: 0;
      letter-spacing: -2px;
      color: #ababab;
    }

    .time {
      font-weight: bold;
      color: #404040;
    }

    .divider {
      width: 40px;
      margin: 0 auto;
      border-width: 3px;
    }
  }
}

@media (orientation: landscape) {
  .adsum-clock-wrapper {
    height: 100%;

    .adsum-clock {
      font-size: 2.3em;

      .day-date {
        font-size: 1.0em;
      }
    }
  }
}

@media (orientation: portrait) {
  .adsum-clock-wrapper {

    .adsum-clock {
      font-size: 1.8em;
      text-align: right;

      .day-date {
        font-size: 0.7em;
      }
    }
  }
}
`}
                            height="400px"
                            width="400px"
                        />
                    </div>
                </div>

                <h3>
                    All the props, which your custom ClockUi component will receive:
                </h3>

                <div className="snippetWrapper">
                    <div className="code">
                        <AceEditor
                            mode="jsx"
                            theme="monokai"
                            name="UNIQUE_ID_OF_DIV"
                            editorProps={{ $blockScrolling: true }}
                            fontSize={14}
                            value={`
import AdsumClock from "@adactive/arc-clock";

const ClockUi = props => (
    <div>
        { JSON.stringify(props) }
    </div>
);
const Clock = AdsumClock(ClockUi);

<Clock lang="en" timeFormat="12hrs" />
`}
                            height="250px"
                            width="500px"
                        />
                    </div>
                    <div className="comp">
                        <Clock2 lang="en" timeFormat="12hrs" />
                    </div>
                </div>

                <h3>
                    EXAMPLES
                </h3>

                <div className="snippetWrapper">
                    <div className="comp">
                        <Clock lang="en" timeFormat="12hrs" />
                    </div>
                    <div className="code">
                        <AceEditor
                            mode="jsx"
                            theme="monokai"
                            name="UNIQUE_ID_OF_DIV"
                            editorProps={{ $blockScrolling: true }}
                            fontSize={14}
                            value={`import AdsumClock from "@adactive/arc-clock";
import "./clock.css";

const ClockUi = (props) => (
    <div role="presentation" className="adsum-clock-wrapper">
        <div className="adsum-clock">
            <div className="day-date">{props.dateStr}</div>
            <div className="time">{props.timeStr}</div>
        </div>
    </div>
);

const Clock = AdsumClock(ClockUi);

<Clock lang="en" timeFormat="12hrs" />
                            `}
                            height="300px"
                            width="600px"
                        />
                    </div>
                </div>

                <div className="snippetWrapper">
                    <div className="comp">
                        <Clock lang="fr" timeFormat="24hrs" />
                    </div>
                    <div className="code">
                        <AceEditor
                            mode="jsx"
                            theme="monokai"
                            name="UNIQUE_ID_OF_DIV"
                            editorProps={{ $blockScrolling: true }}
                            fontSize={14}
                            value={`import AdsumClock from "@adactive/arc-clock";
import "./clock.css";

const ClockUi = (props) => (
    <div role="presentation" className="adsum-clock-wrapper">
        <div className="adsum-clock">
            <div className="day-date">{props.dateStr}</div>
            <div className="time">{props.timeStr}</div>
        </div>
    </div>
);

const Clock = AdsumClock(ClockUi);

<Clock lang="fr" timeFormat="24hrs" />
                            `}
                            height="300px"
                            width="600px"
                        />
                    </div>
                </div>

                <div className="snippetWrapper">
                    <div className="comp">
                        <Clock lang="zh" timeFormat="24hrs" />
                    </div>
                    <div className="code">
                        <AceEditor
                            mode="jsx"
                            theme="monokai"
                            name="UNIQUE_ID_OF_DIV"
                            editorProps={{ $blockScrolling: true }}
                            fontSize={14}
                            value={`import AdsumClock from "@adactive/arc-clock";
import "./clock.css";

const ClockUi = (props) => (
    <div role="presentation" className="adsum-clock-wrapper">
        <div className="adsum-clock">
            <div className="day-date">{props.dateStr}</div>
            <div className="time">{props.timeStr}</div>
        </div>
    </div>
);

const Clock = AdsumClock(ClockUi);

<Clock lang="zh" timeFormat="24hrs" />
                            `}
                            height="300px"
                            width="600px"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js